import { useEffect, useState } from 'react';

/** Live media-query match. */
export function useMedia(query) {
    const get = () => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query).matches : false);
    const [match, setMatch] = useState(get);
    useEffect(() => {
        if (!window.matchMedia) return undefined;
        const mq = window.matchMedia(query);
        const on = () => setMatch(mq.matches);
        on();
        mq.addEventListener('change', on);
        return () => mq.removeEventListener('change', on);
    }, [query]);
    return match;
}

/** < 768 px — the design's mobile breakpoint. */
export const useIsMobile = () => useMedia('(max-width: 767px)');

/**
 * Content-box width of an element, tracked with ResizeObserver.
 * Returns [callbackRef, width] — pass callbackRef as `ref`; works when the element mounts later.
 */
export function useElementWidth(initial = 1200) {
    const [el, setEl] = useState(null);
    const [w, setW] = useState(initial);
    useEffect(() => {
        if (!el) return undefined;
        setW(el.getBoundingClientRect().width);
        const ro = new ResizeObserver((e) => setW(e[0].contentRect.width));
        ro.observe(el);
        return () => ro.disconnect();
    }, [el]);
    return [setEl, w];
}
